import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { FileUploadModule } from 'ng2-file-upload';

import { JYoguiSharedModule } from '../../shared';

import { EventReservation } from './event-reservation.model';
import { EventReservationService } from './event-reservation.service';
import { EventReservationPopupService } from './event-reservation-popup.service';
import { EventReservationPopupComponent } from './event-reservation-dialog.component';
import { EventReservationDialogComponent } from './event-reservation-dialog.component';
import { EventReservationResolvePagingParams } from './event-reservation.route';
import { eventReservationRoute, eventReservationPopupRoute } from './event-reservation.route';
import { EventReservationDeleteDialogComponent } from './event-reservation-delete-dialog.component';
import { EventReservationDeletePopupComponent } from './event-reservation-delete-dialog.component';
import { EventReservationPayDialogComponent, EventReservationPayPopupComponent } from './event-reservation-pay-dialog.component';
import { EventReservationComponent } from './event-reservation.component';



let ENTITY_STATES = [
    ...eventReservationRoute,
    ...eventReservationPopupRoute,
];

@NgModule({
    imports: [
        JYoguiSharedModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true }),
        FileUploadModule
    ],
    declarations: [
        EventReservationPopupComponent,
        EventReservationDialogComponent,
        EventReservationDeleteDialogComponent,
        EventReservationDeletePopupComponent,
        EventReservationPayDialogComponent,
        EventReservationPayPopupComponent,
        EventReservationComponent
    ],
    entryComponents: [
        EventReservationPopupComponent,
        EventReservationDialogComponent,
        EventReservationDeleteDialogComponent,
        EventReservationDeletePopupComponent,
        EventReservationPayDialogComponent,
        EventReservationPayPopupComponent,
        EventReservationComponent
    ],
    providers: [
        EventReservationPopupService,
        EventReservationResolvePagingParams,
        EventReservationService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class JYoguiEventReservationModule { }



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/event-reservation/event-reservation.module.ts